import searchTemplate from './search.html';

@Inject('$window', 'gettextCatalog', '$transclude', 'Responsive')
class SearchComponentController {
  constructor() {
    this.showFilter = false;
    this.isAdditionalContent = this.$transclude.isSlotFilled('additionalContent');
    this.isInnerAdditionalContent = this.$transclude.isSlotFilled('innerAdditionalContent');
  }
  
  $onInit(){
    this.noFloat = this.noFloat || false;
    this.searchButtonLabel = this.searchButtonLabel || this.gettextCatalog.getString('Search');
  }

  async onSearch(form) {
    await this.searchFilters(form);
    this.showFilter = false;
  }

  async onReset() {
    await this.clearFilters();
    this.showFilter = false;
  }
}

export default class SearchComponent {
  constructor() {
    this.controller = SearchComponentController;
    this.transclude = {
      actionButtons: '?actionButtons',
      filters: '?filters',
      header: '?header',
      additionalContent: '?additionalContent',
      innerAdditionalContent: '?innerAdditionalContent',
    };
    this.template = searchTemplate;
    this.bindings = {
      searchFilters: '&',
      clearFilters: '&',
      hideSearchButton: '@?',
      hideResetButton: '@?',
      showHeader: '@?',
      idPrefix: '@?',
      searchButtonLabel: '@?',
      noFloat: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/search/search-component.js